import React, { useEffect, useState } from 'react';
import '../../App.css';
import { AuthService } from '../../APIService/AuthService';
import { useParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, MenuItem } from '@mui/material';

interface RegistrationData {
    fname: string;
    lname: string;
    phone: string;
}

export default function AnotherAdopterRegistration(): JSX.Element {
    const params = useParams<{ key: string }>();
    const validationCode = params.key;

    const [loading, setLoading] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [alertMesage, setAlertMesage] = useState<string>('');
    const [alertHeader, setAlertHeader] = useState<string>('');
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [isHideForm, setIsHideForm] = useState<boolean>(false);

    useEffect(() => {
        const run = async (): Promise<void> => {
            if (!validationCode) return;
            if (!loading) setLoading(true);

            try {
                const validateResp: any = await AuthService.userRegistrationValidate({ validationcode: validationCode });

                if (!validateResp.success) {
                    setAlertHeader('Failed');
                    setAlertMesage('Registration failed. Please ask the inviter for a new invitation link.');
                    setOpen(true);
                    return;
                }

                const data = (validateResp.data as any)?.data ?? validateResp.data;
                const registrationPayload = {
                    validationcode: validationCode,
                    firstname: data?.fname ?? '',
                    lastname: data?.lname ?? '',
                    phone: data?.phone ?? '',
                };

                const registrationResp: any = await AuthService.userRegistration(registrationPayload);

                if (registrationResp.success) {
                    setIsSuccess(true);
                    setAlertHeader('Registration Success');
                    setAlertMesage('Registration successful.');
                } else {
                    const msg =
                        (typeof registrationResp.data === 'string' && registrationResp.data) ||
                        (registrationResp.errorResponse as { errorDescription?: string } | undefined)?.errorDescription ||
                        'Registration failed. Please ask the inviter for a new invitation link.';
                    setAlertHeader('Failed');
                    setAlertMesage(msg);
                }

                setOpen(true);
            } catch (error) {
                console.error(error);
                setAlertHeader('Failed');
                setAlertMesage('Registration failed. Please ask the inviter for a new invitation link');
                setOpen(true);
            } finally {
                setLoading(false);
            }
        };

        void run();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validationCode]);

    const handleClose = (): void => {
        if (isSuccess) {
            setIsHideForm(true);
        }
        setOpen(false);
    };

    return (
        <div>
            {loading && (
                <CircularProgress
                    size={24}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                    }}
                />
            )}
            <Dialog
                fullWidth
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {alertHeader}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {alertMesage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div >
    );
}
